module.exports = __webpack_public_path__ + "static/media/3-1.c81babf7.png";